import classNames from 'classnames';
import React, { FC } from 'react';
import { useRouter } from 'next/router';
import CommonBanner from '../../components/CommonBanner';
import Comma from '../../components/Comma';
import { GyIndexCard, IndexDescription } from '../../components/GyIndexCard';

import { Image } from '../../components/Image';
import PGMap from '../PGMap';
import { NotSupportWebgl } from '../PGMap/NotSupportWebgl';

import styles from './PGTopBanner.module.scss';

interface Props {
  PGTopBannerData: { [key: string]: string };
  PGtopAmoutData: Array<{ [key: string]: string }>;
}
const PGTopBanner: FC<Props> = (props) => {
  const { PGTopBannerData, PGtopAmoutData } = props;
  const { topImg, introText1, introText2, introText3, amout, title, unit, dataSrc } = PGTopBannerData;

  // const bannerConfig = {
  //   bgUrl: topImg,
  //   cardBodyCls: styles['pgtop-banner-card-content-container'],
  // };

  const bannerConfig = {
    bgUrl: topImg,
    bgCls: 'h-17.5r lg:h-[1000px] bg-cover bg-top bg-no-repeat',
    topBannerModel: 'bg',
  };
  const router = useRouter();
  const { locale = 'zh-CN' } = router;
  const gyTopImgMap: { [key: string]: string } = {
    'zh-HK': 'https://img.meituan.net/smartvenus/a4815e9468576e3e479b5609eed89513170668.png',
    'zh-CN': 'https://img.meituan.net/smartvenus/011787f519f8158a46a60181ca878dc488870.png',
    'en-US': 'https://p0.meituan.net/smartvenus/8b710a21287979643ee9c3a49a53f2e7147238.png',
  };

  return (
    <section className={styles['pg-banner-box']}>
      <CommonBanner {...bannerConfig} enableGradient cardCls={styles.wrap}>
        <div>
          <div className={classNames(styles[`titleimg-box-${locale}`])}>
            <Image src={gyTopImgMap[locale]} layout="fill" objectFit="cover" />
          </div>
          <div className={styles['intro-text-box']}>
            <p className={styles['intro-text-item']}>{introText1}</p>
            <div className={styles['intro-text-item-wrap']}>
              <p className={styles['intro-text-item']}>{introText2}</p>
              <span className={styles['comma-box']}>
                <Comma />
              </span>
              <p className={styles['intro-text-item']}>{introText3}</p>
            </div>
          </div>
          {/* <div className={styles['title-box']}>
            <h2 className={styles['title-item']}>{amoutFtext}</h2>
            <h2 className={classNames(styles['title-item'], styles['title-amout'])}>{amout}</h2>
            <h2 className={styles['title-item']}>{amoutEtext}</h2>
          </div>
          <div className={styles['amout-data-box']}>
            {PGtopAmoutData?.map((item, index) => (
              <div key={index} className={styles['amout-data-item']}>
                <div className={styles['item-amount-box']}>
                  <span className={styles['item-amount']}>{item.amount}</span>
                  <span className={styles['item-unit']}>{item.unit}</span>
                </div>
                <div className={styles['item-remark']}>{item.remark}</div>
              </div>
            ))}
          </div> */}
          <GyIndexCard title={title} unit={unit} count={amout} index={PGtopAmoutData as any} />
          {/* 英文版本不展示地图 */}
          {locale !== 'en-US' ? (
            <div className={styles['map-box']}>
              <NotSupportWebgl>
                <PGMap lanType={locale} />
              </NotSupportWebgl>
            </div>
          ) : null}
          <IndexDescription title={dataSrc} />
        </div>
      </CommonBanner>
    </section>
  );
};
PGTopBanner.defaultProps = {};

PGTopBanner.displayName = 'PGTopBanner';
export default PGTopBanner;
